/* VÖRR 30-09 — AVISE-ME em tamanho esgotado (arquivo isolado).
   Só lê o estado do produto: não altera o botão de comprar, o seletor de tamanhos nem apps.
   Vale para o produto principal e para produtos de outras seções da página (ex.: "Compre o look completo").
   Quando o tamanho selecionado está esgotado, o AVISE-ME aparece exatamente por cima do botão
   "Esgotado", que segue ocupando o mesmo espaço (sem deslocamento de layout). */
(function () {
  'use strict';
  if (window.__vorrAviseMe) return;
  window.__vorrAviseMe = true;

  var cfgEl = document.getElementById('vorr-am-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.variants || !cfg.variants.length || !cfg.endpoint) return;

  var variantsById = {};
  cfg.variants.forEach(function (v) { variantsById[String(v.id)] = v; });

  var STORAGE_KEY = 'vorr_am_contato';
  var state = { modal: null, lastFocus: null, openedAt: 0, sending: false, modalVariant: null, modalEntry: null };

  /* Cada produto com botão de compra na página vira uma "entrada": o produto principal (dados do snippet)
     e produtos de outras seções, como "Compre o look completo" (dados lidos do seletor de variantes da seção). */
  var entries = [];
  var pageData = { pid: String(cfg.productId), variantsById: variantsById, sizeIndex: cfg.sizeIndex, title: cfg.title, image: cfg.image };

  /* ---------- leitura do estado do produto ---------- */
  function findAtc() {
    var list = document.querySelectorAll('button[id^="product-buy-btn-' + cfg.productId + '-"]');
    for (var i = 0; i < list.length; i++) {
      if (/MainSection|__main$/.test(list[i].id)) return list[i];
    }
    return list[0] || null; // templates com outro nome de seção principal: o 1º botão do produto é o principal
  }

  function dataFromSection(atc, pid) {
    var sec = atc.closest('[id^="shopify-section-"]') || document;
    var vp = sec.querySelector('variant-picker[data-product-id="' + pid + '"]');
    var js = vp && vp.querySelector('script[data-variant-picker-variants]');
    if (!js) return null;
    var list;
    try { list = JSON.parse(js.textContent); } catch (e) { return null; }
    if (!list || !list.length) return null;
    var sizeIndex = -1;
    Array.prototype.forEach.call(vp.querySelectorAll('[data-variant-picker-option-labels]'), function (n, i) {
      if (sizeIndex < 0 && /tamanho|size|numera|^tam$/i.test(n.getAttribute('option-picker-name') || '')) sizeIndex = i;
    });
    var byId = {};
    var image = null;
    list.forEach(function (v) {
      byId[String(v.id)] = { id: v.id, title: v.title, available: v.available, sku: v.sku, options: v.options };
      if (!image && v.featured_image && v.featured_image.src) image = v.featured_image.src;
    });
    var f = list[0];
    var suffix = ' - ' + f.title;
    var title = (f.name && f.name.slice(-suffix.length) === suffix) ? f.name.slice(0, -suffix.length) : (f.name || '');
    if (image) image = image + (image.indexOf('?') === -1 ? '?' : '&') + 'width=160';
    return { pid: String(pid), variantsById: byId, sizeIndex: sizeIndex, title: title, image: image };
  }

  function currentVariant(en) {
    if (!en || !en.atc) return null;
    var form = en.atc.form || en.atc.closest('form');
    if (!form) return null;
    var input = form.querySelector('input[name="id"]');
    if (!input || !input.value) return null;
    return en.data.variantsById[String(input.value)] || null;
  }

  function sizeLabel(v, data) {
    if (!v) return '';
    var idx = data ? data.sizeIndex : cfg.sizeIndex;
    if (idx >= 0 && v.options && v.options[idx] != null) return String(v.options[idx]);
    return v.title === 'Default Title' ? 'Único' : String(v.title);
  }

  /* ---------- botão AVISE-ME (por cima do "Esgotado", mesmo tamanho) ---------- */
  function ensureButton(en) {
    var atc = en.atc;
    if (en.btn && en.btn.isConnected && en.btn.previousElementSibling === atc) return en.btn;
    if (en.btn && en.btn.parentNode) en.btn.parentNode.removeChild(en.btn);
    var keep = atc.className.split(/\s+/).filter(function (c) {
      return /^btn(--[a-z0-9-]+)?$/.test(c) && c !== 'btn--vpp-prime';
    });
    var b = document.createElement('button');
    b.type = 'button';
    b.className = keep.join(' ') + ' vorr-am-btn';
    b.setAttribute('aria-haspopup', 'dialog');
    b.innerHTML = '<span class="vorr-am-btn__label">AVISE-ME</span>';
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openModal(en.variant, en);
    });
    atc.insertAdjacentElement('afterend', b);
    en.btn = b;
    return b;
  }

  function positionBtn(btn, atc) {
    var wrap = atc.parentNode;
    if (wrap && getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
    btn.style.top = atc.offsetTop + 'px';
    btn.style.left = atc.offsetLeft + 'px';
    btn.style.width = atc.offsetWidth + 'px';
    btn.style.height = atc.offsetHeight + 'px';
  }

  function syncEntry(en) {
    var atc = en.atc;
    var v = currentVariant(en);
    var soldOut = !!(v && v.available === false);
    en.variant = v;
    var btn = ensureButton(en);
    if (btn.disabled) btn.disabled = false;
    if (soldOut) {
      // O "Esgotado" continua ocupando o mesmo espaço (só fica invisível) e o AVISE-ME é
      // posicionado exatamente por cima: nada na página sobe ou desce.
      positionBtn(btn, atc);
      if (!btn.classList.contains('is-active')) btn.classList.add('is-active');
      if (!atc.classList.contains('vorr-am-under')) atc.classList.add('vorr-am-under');
    } else {
      if (btn.classList.contains('is-active')) btn.classList.remove('is-active');
      if (atc.classList.contains('vorr-am-under')) atc.classList.remove('vorr-am-under');
    }
    initSticky(en);
  }

  function entryFor(atc, data) {
    for (var i = 0; i < entries.length; i++) if (entries[i].atc === atc) return entries[i];
    if (!data) return null;
    var en = { atc: atc, data: data, btn: null, variant: null, stk: { bar: null } };
    entries.push(en);
    observeEntry(en);
    return en;
  }

  function sync() {
    // remove entradas de botões que saíram da página (seção re-renderizada)
    entries = entries.filter(function (en) {
      if (en.atc.isConnected) return true;
      if (en.btn && en.btn.parentNode) en.btn.parentNode.removeChild(en.btn);
      if (en.obsA) en.obsA.disconnect();
      if (en.obsS) en.obsS.disconnect();
      return false;
    });
    var main = findAtc();
    if (main) syncEntry(entryFor(main, pageData));
    var all = document.querySelectorAll('button[id^="product-buy-btn-"]');
    for (var i = 0; i < all.length; i++) {
      var b = all[i];
      if (b === main) continue;
      var m = b.id.match(/^product-buy-btn-(\d+)-/);
      if (!m || m[1] === String(cfg.productId)) continue;
      if (b.closest('quick-add-modal, [id*="quick-add"], [id*="QuickAdd"]')) continue;
      var en = entryFor(b, null);
      if (!en) {
        var data = dataFromSection(b, m[1]);
        if (!data) continue;
        en = entryFor(b, data);
      }
      syncEntry(en);
    }
  }

  /* ---------- barra flutuante do desktop (vorr-sticky-atc): mesmo comportamento da página ----------
     Tamanho esgotado na seleção da barra passa a ser clicável (continua riscado). Ao escolher um,
     o botão da barra vira o AVISE-ME cinza no mesmo lugar e tamanho; clicar abre o popup com aquele
     tamanho. Tamanho com estoque segue o fluxo normal de compra da barra. Produto todo esgotado:
     o "ESGOTADO" da barra vira AVISE-ME e abre a seleção de tamanho. O arquivo da barra não é alterado. */
  function convertStickySizes(en) {
    var stk = en.stk;
    if (!stk.list) return;
    Array.prototype.forEach.call(stk.list.querySelectorAll('.vorr-sticky-atc__size[disabled]'), function (s) {
      var id = s.getAttribute('data-variant');
      if (!id || !en.data.variantsById[id]) return; // combinação inexistente continua travada
      s.disabled = false;
      s.classList.add('vorr-am-size-out');
      s.setAttribute('aria-label', s.textContent + ' (esgotado, avise-me)');
    });
    Array.prototype.forEach.call(stk.list.querySelectorAll('.vorr-am-size-out'), function (s) {
      var cur = s.getAttribute('data-variant') === stk.picked;
      if (s.classList.contains('is-current') !== cur) s.classList.toggle('is-current', cur);
    });
  }

  function updateSticky(en) {
    var stk = en.stk;
    if (!stk.btn || !stk.bar.isConnected) return;
    if (stk.pop.hidden) stk.picked = null;
    var active = !!stk.picked || stk.sbtn.disabled;
    if (active) {
      if (stk.sbtn.offsetParent === stk.bar) {
        stk.btn.style.top = stk.sbtn.offsetTop + 'px';
        stk.btn.style.left = stk.sbtn.offsetLeft + 'px';
        stk.btn.style.width = stk.sbtn.offsetWidth + 'px';
        stk.btn.style.height = stk.sbtn.offsetHeight + 'px';
      }
      if (!stk.btn.classList.contains('is-active')) stk.btn.classList.add('is-active');
      if (!stk.sbtn.classList.contains('vorr-am-under')) stk.sbtn.classList.add('vorr-am-under');
    } else {
      if (stk.btn.classList.contains('is-active')) stk.btn.classList.remove('is-active');
      if (stk.sbtn.classList.contains('vorr-am-under')) stk.sbtn.classList.remove('vorr-am-under');
    }
    convertStickySizes(en);
  }

  function initSticky(en) {
    if (en.stk.bar && en.stk.bar.isConnected) return;
    var bar = document.querySelector('.vorr-sticky-atc[data-main-btn="' + en.atc.id + '"]');
    if (!bar) return;
    var sbtn = bar.querySelector('.vorr-sticky-atc__btn');
    var pop = bar.querySelector('[data-vsa-sizes]');
    var list = bar.querySelector('[data-vsa-sizes-list]');
    if (!sbtn || !pop || !list) return;
    var stk = en.stk = { bar: bar, sbtn: sbtn, pop: pop, list: list, btn: null, picked: null };

    var b = document.createElement('button');
    b.type = 'button';
    b.className = sbtn.className.split(/\s+/).filter(function (c) {
      return /^btn(--[a-z0-9-]+)?$/.test(c) && c !== 'btn--vpp-prime';
    }).join(' ') + ' vorr-am-btn vorr-am-btn--sticky';
    b.setAttribute('aria-haspopup', 'dialog');
    b.innerHTML = '<span class="vorr-am-btn__label">AVISE-ME</span>';
    sbtn.insertAdjacentElement('afterend', b);
    stk.btn = b;

    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var picked = stk.picked && en.data.variantsById[stk.picked];
      if (picked) {
        var close = bar.querySelector('[data-vsa-sizes-close]');
        if (close && !pop.hidden) close.click();
        openModal(picked, en);
        return;
      }
      var many = Object.keys(en.data.variantsById).length > 1 && en.data.sizeIndex >= 0;
      if (!many) { openModal(currentVariant(en) || en.data.variantsById[Object.keys(en.data.variantsById)[0]], en); return; }
      // produto todo esgotado: abre a seleção de tamanho da própria barra
      sbtn.disabled = false;
      sbtn.click();
    });

    // clique em tamanho esgotado: marca o tamanho e troca o botão da barra pelo AVISE-ME
    list.addEventListener('click', function (e) {
      var s = e.target.closest ? e.target.closest('.vorr-am-size-out') : null;
      if (!s) return;
      e.preventDefault();
      e.stopPropagation();
      stk.picked = s.getAttribute('data-variant');
      updateSticky(en);
    }, true);

    var upd = function () { updateSticky(en); };
    new MutationObserver(function () { convertStickySizes(en); }).observe(list, { childList: true });
    new MutationObserver(upd).observe(pop, { attributes: true, attributeFilter: ['hidden'] });
    new MutationObserver(upd).observe(sbtn, { attributes: true, attributeFilter: ['disabled'] });
    window.addEventListener('resize', upd);
    updateSticky(en);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sync(); });
  }

  function observeEntry(en) {
    en.obsA = new MutationObserver(schedule);
    en.obsA.observe(en.atc, { attributes: true, attributeFilter: ['disabled', 'aria-label'], childList: true, subtree: true, characterData: true });
    var section = en.atc.closest('[id^="shopify-section-"]') || en.atc.closest('product-form');
    if (section) {
      en.obsS = new MutationObserver(schedule);
      en.obsS.observe(section, { childList: true, subtree: true });
    }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !(t.type === 'radio' || t.tagName === 'SELECT')) return;
    schedule();
    setTimeout(sync, 150);
    setTimeout(sync, 500);
  }, true);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('resize', schedule);

  /* ---------- popup ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function maskPhone(d) {
    d = d.slice(0, 11);
    if (!d) return '';
    if (d.length <= 2) return '(' + d;
    if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    if (d.length <= 10) return '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }

  function phoneDigits(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.length > 11 && d.indexOf('55') === 0) d = d.slice(2);
    return d;
  }

  function buildModal() {
    var el = document.createElement('div');
    el.className = 'vorr-am';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="vorr-am__overlay" data-am-close></div>' +
      '<div class="vorr-am__panel" role="dialog" aria-modal="true" aria-labelledby="vorr-am-title">' +
        '<button type="button" class="vorr-am__close" data-am-close aria-label="Fechar">&times;</button>' +
        '<div data-am-view="form">' +
          '<h2 class="vorr-am__title" id="vorr-am-title">Esse tamanho esgotou...</h2>' +
          '<p class="vorr-am__text vorr-am__fit" data-am-fit="14">Deixe seu contato e avisamos assim que ele voltar ao estoque.</p>' +
          '<div class="vorr-am__product">' +
            '<img class="vorr-am__thumb" alt="" width="56" height="70" hidden>' +
            '<div><p class="vorr-am__pname"></p>' +
            '<p class="vorr-am__psize">Tamanho <strong data-am-size></strong></p></div>' +
          '</div>' +
          '<form class="vorr-am__form" novalidate>' +
            '<label class="vorr-am__field"><span>Nome</span><input name="nome" type="text" autocomplete="name" maxlength="80" required></label>' +
            '<label class="vorr-am__field"><span>E-mail</span><input name="email" type="email" autocomplete="email" inputmode="email" maxlength="120" required></label>' +
            '<label class="vorr-am__field"><span>WhatsApp</span><input name="telefone" type="tel" autocomplete="tel-national" inputmode="numeric" placeholder="(31) 99999-9999" maxlength="16" required></label>' +
            '<label class="vorr-am__check"><input type="checkbox" name="marketing"><span>Quero receber novidades e lançamentos da VÖRR</span></label>' +
            '<input type="text" name="am_ref_x" class="vorr-am__hp" tabindex="-1" autocomplete="off" data-lpignore="true" data-1p-ignore aria-hidden="true">' +
            '<p class="vorr-am__error" role="alert" hidden></p>' +
            '<button type="submit" class="vorr-am__cta">AVISE-ME</button>' +
          '</form>' +
          '<p class="vorr-am__legal vorr-am__fit" data-am-fit="11">Seus dados servem só para este aviso e, se marcado, para novidades.</p>' +
        '</div>' +
        '<div data-am-view="ok" hidden>' +
          '<h2 class="vorr-am__title">Pronto, você está na lista</h2>' +
          '<p class="vorr-am__text vorr-am__fit" data-am-fit="14">Avisamos quando o tamanho <strong data-am-size></strong> voltar ao estoque.</p>' +
          '<button type="button" class="vorr-am__cta" data-am-close>CONTINUAR COMPRANDO</button>' +
        '</div>' +
        // VÖRR 07-10: rodapé "Desenvolvido por Techzafe" (mesmo padrão do pop-up de feedback)
        '<style>.vorr-am__credit{display:flex;align-items:center;justify-content:center;gap:6px;width:max-content;margin:14px auto 0;font-size:11px;line-height:1;color:#6b6b6b!important;text-decoration:none!important}.vorr-am__credit svg{display:block;width:auto;height:12px;color:#0a0a0a}.vorr-am__credit:hover{opacity:.8}</style>' +
        '<a class="vorr-am__credit" href="https://www.techzafe.com/" target="_blank" rel="noopener"><span>Desenvolvido por</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="2 1 103 21" aria-hidden="true" focusable="false"><path fill="#3561CE" d="M3 3H16L15 6H11.6V18H8.2V6H4ZM17 3H25L22.6 6.2L17.6 15H21L20 18.2H13L14 15.2L19 6.2H16.4ZM25 4H28.2L31 10.8L26.8 18.2H23.4L27.4 10.8Z"/><path fill="currentColor" d="M37.4 5.6L44.7 5.6L44.7 7.2L42.1 7.2L42.1 15.6L40.1 15.6L40.1 7.2L37.4 7.2L37.4 5.6M51.9 7.2L48.2 7.2L48.2 9.7L51.5 9.7L51.5 11.3L48.2 11.3L48.2 13.9L51.9 13.9L51.9 15.6L46.2 15.6L46.2 5.6L51.9 5.6L51.9 7.2M53.3 10.6Q53.3 9.1 53.9 7.9Q54.6 6.8 55.7 6.1Q56.9 5.5 58.3 5.5Q60.0 5.5 61.2 6.3Q62.5 7.2 63.0 8.7L60.7 8.7Q60.4 8.0 59.7 7.6Q59.1 7.3 58.3 7.3Q57.4 7.3 56.8 7.7Q56.1 8.1 55.7 8.8Q55.3 9.6 55.3 10.6Q55.3 11.5 55.7 12.3Q56.1 13.0 56.8 13.5Q57.4 13.9 58.3 13.9Q59.1 13.9 59.7 13.5Q60.4 13.1 60.7 12.4L63.0 12.4Q62.5 13.9 61.3 14.8Q60.0 15.6 58.3 15.6Q56.9 15.6 55.7 15.0Q54.6 14.3 53.9 13.2Q53.3 12.0 53.3 10.6M71.0 5.6L73.0 5.6L73.0 15.6L71.0 15.6L71.0 11.3L66.7 11.3L66.7 15.6L64.7 15.6L64.7 5.6L66.7 5.6L66.7 9.7L71.0 9.7L71.0 5.6M80.3 9.3L76.8 13.9L80.3 13.9L80.3 15.6L74.5 15.6L74.5 13.9L78 9.3L74.5 9.3L74.5 7.7L80.3 7.7L80.3 9.3M81.3 11.6Q81.3 10.4 81.8 9.4Q82.3 8.5 83.1 8.0Q83.9 7.5 84.9 7.5Q85.8 7.5 86.5 7.9Q87.1 8.2 87.5 8.8L87.5 7.7L89.6 7.7L89.6 15.6L87.5 15.6L87.5 14.4Q87.2 15 86.5 15.3Q85.8 15.7 84.9 15.7Q83.9 15.7 83.1 15.2Q82.3 14.7 81.8 13.7Q81.3 12.8 81.3 11.6M87.5 11.6Q87.5 10.9 87.3 10.4Q87.0 9.8 86.5 9.6Q86.0 9.3 85.4 9.3Q84.9 9.3 84.4 9.5Q83.9 9.8 83.7 10.3Q83.4 10.9 83.4 11.6Q83.4 12.3 83.7 12.8Q83.9 13.4 84.4 13.6Q84.9 13.9 85.4 13.9Q86.0 13.9 86.5 13.7Q87.0 13.4 87.3 12.9Q87.5 12.3 87.5 11.6M95.1 7.7L95.1 9.3L93.7 9.3L93.7 15.6L91.7 15.6L91.7 9.3L90.8 9.3L90.8 7.7L91.7 7.7L91.7 7.3Q91.7 5.8 92.5 5.1Q93.4 4.4 95.0 4.5L95.0 6.2Q94.3 6.1 94.0 6.4Q93.7 6.7 93.7 7.3L93.7 7.7L95.1 7.7M103.8 11.4Q103.8 11.9 103.7 12.2L97.9 12.2Q98.0 13.1 98.5 13.5Q99.1 14.0 99.8 14.0Q100.9 14.0 101.4 13.1L103.6 13.1Q103.2 14.2 102.3 14.9Q101.3 15.7 99.9 15.7Q98.7 15.7 97.8 15.2Q96.9 14.7 96.4 13.7Q95.9 12.8 95.9 11.6Q95.9 10.4 96.4 9.4Q96.9 8.5 97.8 8.0Q98.7 7.5 99.9 7.5Q101.0 7.5 101.9 8.0Q102.8 8.5 103.3 9.4Q103.8 10.3 103.8 11.4M98 10.9L101.7 10.9Q101.7 10.1 101.1 9.6Q100.6 9.2 99.8 9.2Q99.1 9.2 98.6 9.6Q98.1 10.1 98 10.9"/></svg><span class="vorr-am__hp">Techzafe (abre em nova aba)</span></a>' +
      '</div>';
    document.body.appendChild(el);

    var form = el.querySelector('form');
    form.addEventListener('submit', onSubmit);
    form.telefone.addEventListener('input', function () {
      this.value = maskPhone(phoneDigits(this.value));
    });
    el.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-am-close]')) closeModal();
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(
        el.querySelectorAll('button, input:not([tabindex="-1"])'),
        function (n) { return n.offsetParent !== null && !n.disabled; }
      );
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    return el;
  }

  function prefill(form) {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) {}
    var c = cfg.customer || {};
    if (!form.nome.value) form.nome.value = (saved && saved.nome) || c.name || '';
    if (!form.email.value) form.email.value = (saved && saved.email) || c.email || '';
    if (!form.telefone.value) form.telefone.value = maskPhone(phoneDigits((saved && saved.telefone) || c.phone || ''));
  }

  // Textos de 1 linha só: começa no tamanho máximo e reduz até caber na largura do popup (desktop e mobile)
  function fitOneLine(el, max) {
    el.style.fontSize = max + 'px';
    var avail = el.clientWidth;
    if (!avail || el.scrollWidth <= avail) return;
    var size = Math.floor(max * avail / el.scrollWidth * 10) / 10;
    el.style.fontSize = size + 'px';
    for (var i = 0; i < 20 && el.scrollWidth > el.clientWidth && size > 6; i++) {
      size -= 0.2;
      el.style.fontSize = size + 'px';
    }
  }

  function fitTexts() {
    if (!state.modal) return;
    Array.prototype.forEach.call(state.modal.querySelectorAll('[data-am-fit]'), function (el) {
      fitOneLine(el, parseFloat(el.getAttribute('data-am-fit')) || 14);
    });
  }

  window.addEventListener('resize', function () {
    if (state.modal && state.modal.classList.contains('is-open')) fitTexts();
  });

  function openModal(v, en) {
    if (!v) return;
    var data = (en && en.data) || pageData;
    state.modalVariant = v;
    state.modalEntry = data;
    if (!state.modal) state.modal = buildModal();
    var m = state.modal;
    var size = sizeLabel(v, data);
    m.querySelector('.vorr-am__pname').textContent = data.title || '';
    var thumb = m.querySelector('.vorr-am__thumb');
    if (data.image) { thumb.src = data.image; thumb.hidden = false; } else { thumb.removeAttribute('src'); thumb.hidden = true; }
    Array.prototype.forEach.call(m.querySelectorAll('[data-am-size]'), function (n) { n.textContent = size; });
    m.querySelector('[data-am-view="form"]').hidden = false;
    m.querySelector('[data-am-view="ok"]').hidden = true;
    var form = m.querySelector('form');
    hideError(form);
    prefill(form);
    state.lastFocus = document.activeElement;
    state.openedAt = Date.now();
    var sw = window.innerWidth - document.documentElement.clientWidth;
    if (sw === 0) document.documentElement.classList.add('vorr-am-lock');
    fitTexts();
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    setTimeout(function () {
      var target = !form.nome.value ? form.nome : !form.email.value ? form.email : !form.telefone.value ? form.telefone : form.querySelector('.vorr-am__cta');
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }, 60);
  }

  function closeModal() {
    var m = state.modal;
    if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vorr-am-lock');
    if (state.lastFocus && state.lastFocus.focus) {
      try { state.lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function showError(form, msg, input) {
    var p = form.querySelector('.vorr-am__error');
    p.textContent = msg;
    p.hidden = false;
    Array.prototype.forEach.call(form.querySelectorAll('input'), function (i) { i.removeAttribute('aria-invalid'); });
    if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
  }

  function hideError(form) {
    var p = form.querySelector('.vorr-am__error');
    p.hidden = true;
    p.textContent = '';
    Array.prototype.forEach.call(form.querySelectorAll('input'), function (i) { i.removeAttribute('aria-invalid'); });
  }

  function onSubmit(e) {
    e.preventDefault();
    if (state.sending) return;
    var form = e.target;
    var v = state.modalVariant;
    var pdata = state.modalEntry || pageData;
    var nome = form.nome.value.trim();
    var email = form.email.value.trim().toLowerCase();
    var tel = phoneDigits(form.telefone.value);

    if (nome.length < 2) return showError(form, 'Informe seu nome.', form.nome);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return showError(form, 'Confira o e-mail informado.', form.email);
    if (tel.length < 10 || tel.length > 11) return showError(form, 'Informe o WhatsApp com DDD.', form.telefone);
    if (!v) return showError(form, 'Selecione o tamanho novamente.');
    hideError(form);

    var payload = {
      nome: nome,
      email: email,
      telefone: '+55' + tel,
      marketing: !!form.marketing.checked,
      empresa: form.am_ref_x.value,
      product_id: pdata.pid,
      variant_id: v.id,
      origem: location.href.split('#')[0]
    };

    var cta = form.querySelector('.vorr-am__cta');
    state.sending = true;
    cta.disabled = true;
    cta.textContent = 'ENVIANDO...';

    // Cliente logado já recebe os campos preenchidos e pode clicar muito rápido: o envio espera
    // no mínimo 1,6 s desde a abertura do popup para não ser confundido com robô pelo endpoint.
    var wait = Math.max(0, 1600 - (Date.now() - state.openedAt));
    new Promise(function (resolve) { setTimeout(resolve, wait); })
      .then(function () {
        payload.t = Date.now() - state.openedAt;
        return fetch(cfg.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify(payload)
        });
      })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok && d && d.ok, d: d }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && res.d.error) || 'erro');
        try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ nome: nome, email: email, telefone: tel })); } catch (err) {}
        state.modal.querySelector('[data-am-view="form"]').hidden = true;
        state.modal.querySelector('[data-am-view="ok"]').hidden = false;
        fitTexts();
        var ok = state.modal.querySelector('[data-am-view="ok"] .vorr-am__cta');
        try { ok.focus({ preventScroll: true }); } catch (err) {}
        var detail = { product_id: pdata.pid, variant_id: v.id, tamanho: sizeLabel(v, pdata), produto: pdata.title };
        try { document.dispatchEvent(new CustomEvent('vorr:avise-me', { detail: detail })); } catch (err) {}
        if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'avise_me', avise_me: detail });
      })
      .catch(function () {
        showError(form, 'Não foi possível registrar agora. Tente de novo em instantes.');
      })
      .then(function () {
        state.sending = false;
        cta.disabled = false;
        cta.textContent = 'AVISE-ME';
      });
  }

  sync();
})();
